import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1000 * 30, // 30초 - 캐시 유지하되 자주 갱신
      refetchOnMount: true, // 페이지 이동 시 자동 갱신
      refetchOnWindowFocus: true, // 탭 전환 후 돌아올 때 자동 갱신
    },
    mutations: {
      retry: 0,
    },
  },
});
